/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-undef */
import React, { useState } from "react";
import SkillListingSkeleton from "../../utils/skeleton/skillListingSkeleton";
import NotFound from "../../components/notFound";
import CustomModal from "../../components/customModal/customModal";
import { useFormik } from "formik";
import {
  CouponInitialValues,
  CouponValidationSchema,
} from "../../utils/validations/coupon";
import { toast } from "react-toastify";
import { numberOnly } from "../../utils/helpers";
import useGet from "../../hooks/useGet";
import ENDPOINTS from "../../services/endPoints";
import QUERY_KEYS from "../../services/queryKeys";
import usePost from "../../hooks/usePost";
import useDelete from "../../hooks/useDelete";

const CouponList = () => {
  const [couponModal, setCouponModal] = useState(false);
  const [deleteCouponModal, setDeleteCouponModal] = useState(false);
  const [deleteCouponId, setDeleteCouponId] = useState(null);
  const {
    data: couponList,
    isLoading: isLoadingCoupon,
    refetch: refetchCoupon,
  } = useGet(ENDPOINTS.GET_COUPON, QUERY_KEYS.CREATE_COUPON_QUERY_KEY);
  console.log(couponList?.data?.coupons, "couponList");
  const { mutateAsync: addCoupon, isLoading: isLoadingAddCoupon } = usePost(
    ENDPOINTS.CREATE_COUPON,
    QUERY_KEYS.CREATE_COUPON_QUERY_KEY
  );
  const {
    isLoading: isLoadingCouponDelete,
    mutateAsync: couponDeleteMutateAsync,
  } = useDelete(
    ENDPOINTS.DELETE_COUPON(deleteCouponId),
    QUERY_KEYS.DELETE_COUPON_QUERY_KEY
  );

  const {
    errors,
    handleBlur,
    handleChange,
    touched,
    resetForm,
    handleSubmit,
    values,
    setFieldValue,
  } = useFormik({
    initialValues: CouponInitialValues,
    validationSchema: CouponValidationSchema,
    onSubmit: async () => {
      try {
        const postData = {
          title: values.title,
          discount: values?.discount,
          limit: values?.limit,
          couponCode: values?.code,
          oneTimeUser: values?.oneTimeUser,
        };
        const response = await addCoupon(postData);

        if (response.statusCode === 200) {
          toast.success(response?.message);
          handleCloseModal();
          refetchCoupon();
        } else {
          toast.error(response?.message);
        }
      } catch (error) {
        toast.error(error.response.data.message);
      }
    },
  });
  const handelOpenModel = () => {
    setCouponModal(true);
  };
  const handleCloseModal = () => {
    setCouponModal(false);
    resetForm();
  };
  const handleGenerateRandomCode = () => {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let code = "COUPON";

    for (let i = 0; i < 4; i++) {
      code += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    setFieldValue("code", code);
  };
  const handleCopyCode = (code) => {
    if (!code) return;

    navigator.clipboard
      .writeText(code)
      .then(() => {
        toast.success("Coupon code copied!");
      })
      .catch((err) => {
        toast.error("Failed to copy: ", err);
      });
  };
  const handelDeleteCouponModal = (id) => {
    setDeleteCouponId(id);
    setDeleteCouponModal(true);
  };
  const onDeleteConfirm = async () => {
    try {
      const response = await couponDeleteMutateAsync();
      if (response.status === true) {
        toast.success(response?.message);
        setDeleteCouponModal(false);
        refetchCoupon();
      } else {
        toast.error("Server error");
      }
    } catch (error) {
      toast.error(error.response);
    }
  };
  return (
    <div>
      <div className="row">
        <div className="col-md-12 mt-4 px-1">
          <div className="card">
            <div className="card-header pb-0 px-3">
              <div className="position-relative my-3 d-flex justify-center">
                <h5 className="mb-0">Coupons List</h5>
                {false ? null : (
                  <button
                    title="Add"
                    type="button"
                    className="btn btn-green text-uppercase position-absolute top-0 end-0"
                    onClick={handelOpenModel}
                  >
                    New Coupon
                  </button>
                )}
              </div>
            </div>
            <div className="card-body pt-4 p-3">
              {isLoadingCoupon ? (
                <SkillListingSkeleton />
              ) : couponList?.data?.coupons.length === 0 ? (
                <NotFound content="Library List Not Found" />
              ) : (
                <ul className="list-group">
                  {couponList?.data?.coupons?.map((item, index) => {
                    return (
                      <li
                        className="list-group-item border-0 p-4 mb-2 bg-gray-100 border-radius-lg"
                        key={index}
                      >
                        <div className="row justify-content-between gy-3">
                          <div className="card-flex d-flex col-sm-10">
                            {/* <img
                              src={item?.resource_json?.image?.added_image}
                              alt="Image"
                              className="item-img rounded-2"
                            /> */}
                            <div
                              className="icon icon-shape icon-2xl me-3 shadow text-center"
                              style={{ backgroundColor: "#006972" }}
                            >
                              <i className="ni ni-tag text-white opacity-10"></i>
                            </div>
                            <div className="item-content d-flex flex-column">
                              <div className="d-flex flex-column gap-2 small text-secondary">
                                <div>
                                  <strong className="text-dark me-1">
                                    Title :
                                  </strong>
                                  {item?.title}
                                </div>
                                <div>
                                  <strong className="text-dark">
                                    Discount Amount :
                                  </strong>{" "}
                                  {`${item?.discount}%`}
                                </div>
                                <div>
                                  <strong className="text-dark">
                                    Usage Limit :
                                  </strong>
                                  <span
                                    className={`ms-2 px-2 py-1 rounded ${
                                      item?.limit === 0 &&
                                      "bg-danger text-white"
                                    }`}
                                  >
                                    {item?.limit === 0
                                      ? "Expired"
                                      : item?.limit ?? "Unlimited"}
                                  </span>
                                </div>
                                 <div>
                                  <strong className="text-dark">Usage Type:</strong>
                                  <span className="ms-2 px-2 py-1 rounded">
                                    {item.oneTimeUser ? 'Single-use' : 'Multi-use'}
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-2">
                                  <strong className="text-dark">
                                    Coupon Code :
                                  </strong>

                                  <div className="d-flex align-items-center justify-content-center gap-2">
                                    <span className="badge bg-light text-dark px-2 py-1">
                                      {item?.couponCode}
                                    </span>
                                    <button
                                      type="button"
                                      className="btn btn-sm "
                                      style={{
                                        border: "1px solid #006972",
                                        color: "#006972",
                                        backgroundColor: "transparent",
                                        padding: "6px",
                                        marginBottom: "1px",
                                      }}
                                      onClick={() =>
                                        handleCopyCode(item?.couponCode)
                                      }
                                    >
                                      Copy Code
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-sm-2 ms-sm-auto text-end">
                            <div className="d-flex flex-column gap-2 gap-sm-6 gap-md-6 ">
                              <div>
                                <a
                                  className="btn btn-link text-danger text-gradient px-3 mb-0"
                                  onClick={() =>
                                    handelDeleteCouponModal(item?._id)
                                  }
                                >
                                  <i className="far fa-trash-alt me-2" />
                                  Delete
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              )}
            </div>
          </div>
        </div>
      </div>
      <CustomModal
        open={couponModal}
        title="Add New Coupon"
        actionTitle="Add"
        cancelTitle="Cancel"
        actionButtonClass="bg-danger"
        onConfirm={handleSubmit}
        isLoading={isLoadingAddCoupon}
        onClose={handleCloseModal}
        customClass="modal-md"
      >
        <div>
          <form>
            <div className="upload_container">
              <div className="w-100 mt-2">
                <div className="d-flex w-100 gap-4">
                  <div className="w-100">
                    <div className="d-flex gap-4">
                      <div className="mb-3  w-100">
                        <div>
                          <label>Enter Title</label>
                          <input
                            type="text"
                            className="form-control form-control-lg"
                            placeholder="Enter Title"
                            name="title"
                            value={values.title}
                            onBlur={handleBlur}
                            onChange={handleChange}
                          />
                        </div>
                        {touched.title && errors.title && (
                          <p className="error mt-1">{errors.title}</p>
                        )}
                      </div>

                      <div className="mb-3  w-100">
                        <div className="mb-3">
                          <label for="cars">Discount Amount </label>
                          <select
                            className="form-control"
                            style={{ padding: "12px" }}
                            name="discount"
                            id="cars"
                            value={values?.discount}
                            onBlur={handleBlur}
                            onChange={handleChange}
                          >
                            <option value="" disabled>
                              Select Discount
                            </option>
                            <option value="10">10%</option>
                            <option value="20">20%</option>
                            <option value="25">25%</option>
                            <option value="50">50%</option>
                            <option value="100">100%</option>
                          </select>
                        </div>
                        {touched.discount && errors.discount && (
                          <p className="error">{errors.discount}</p>
                        )}
                      </div>
                    </div>
                    <div className="d-flex gap-4">
                      <div className="mb-3  w-100">
                        <div>
                          <label>Usage Limit</label>
                          <input
                            type="text"
                            className="form-control form-control-lg"
                            placeholder="10"
                            name="limit"
                            value={values.limit}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            onKeyPress={numberOnly}
                          />
                        </div>
                        {touched.limit && errors.limit && (
                          <p className="error mt-1">{errors.limit}</p>
                        )}
                        {/* <div className="form-text mt-1">
                          Leave empty for unlimited usage
                        </div> */}
                      </div>
                      <div className="mb-3 w-100">
                        <div>
                          <label>Coupon Code</label>
                          <input
                            type="text"
                            name="code"
                            className="form-control form-control-lg"
                            placeholder="COUPab34"
                            value={values.code}
                            onBlur={handleBlur}
                            onChange={handleChange}
                          />
                          {touched.code && errors.code && (
                            <p className="error mt-1">{errors.code}</p>
                          )}
                          <button
                            type="button"
                            className="btn btn-secondary btn-sm mt-2"
                            onClick={() => handleGenerateRandomCode()}
                          >
                            Generate Random Code
                          </button>
                        </div>
                      </div>
                    </div>
                    <div>
                      <strong className="text-dark d-block mb-2">Usage Type</strong>

                      <div className="d-flex gap-4">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="oneTimeUser"
                            id="singleUse"
                            checked={values.oneTimeUser === true}
                            onChange={() =>
                              handleChange({ target: { name: 'oneTimeUser', value: true } })
                            }
                            onBlur={handleBlur}
                          />
                          <label className="form-check-label" htmlFor="singleUse">
                            Single-use
                          </label>
                        </div>

                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="oneTimeUser"
                            id="multiUse"
                            checked={values.oneTimeUser === false}
                            onChange={() =>
                              handleChange({ target: { name: 'oneTimeUser', value: false } })
                            }
                            onBlur={handleBlur}
                          />
                          <label className="form-check-label" htmlFor="multiUse">
                            Multi-use
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </CustomModal>

      <CustomModal
        customClass="sm-modal"
        open={deleteCouponModal}
        title="Coupon Delete"
        actionTitle="Delete"
        cancelTitle="Cancel"
        actionButtonClass="bg-danger"
        onConfirm={onDeleteConfirm}
        isLoading={isLoadingCouponDelete}
        onClose={() => setDeleteCouponModal(false)}
      >
        <div>
          <span>Are you sure you want to delete Coupon?</span>
        </div>
      </CustomModal>
    </div>
  );
};

export default CouponList;
